import React from "react";
import Image from "next/image";
import { Stack } from "@chakra-ui/react";
import ArchitectureImg from "public/openStack/architecture-img.svg";

const ServiceArchitecture = () => {
  return (
    <Stack justify={"center"} align={"center"} gap={8}>
      <Image
        src={ArchitectureImg}
        alt="OneMind Infographic"
        style={{ height: "auto", maxWidth: "1000px", width: "100%" }}
      />
    </Stack>
  );
};

export default ServiceArchitecture;
